import { createI18n } from 'vue-i18n'
import { ar, de, en, es, fr } from 'vuetify/locale'

import arGeneral from './ar/general.ts'
import arHome from './ar/home.ts'
import deGeneral from './de/general.ts'
import deHome from './de/home.ts'
import enGeneral from './en/general.ts'
import enHome from './en/home.ts'
import enMemberManagement from './en/memberManagement.ts'
import enNotFound from './en/notfound.ts'
import enTeamManagement from './en/teamManagement.ts'
import enUnexpectedError from './en/unexpected.ts'
import enValidationError from './en/validationError.ts'
import enWorkspaceManagement from './en/workspaceManagement.ts'
import esGeneral from './es/general.ts'
import esHome from './es/home.ts'
import frGeneral from './fr/general.ts'
import frHome from './fr/home.ts'

// Define the messages object
export const additionalMessages = {
  ar: {
    $vuetify: ar,
    general: arGeneral,
    home: arHome,
    languageName: 'العربية',
    selectLanguage: 'اختر اللغة',
  },
  de: {
    $vuetify: de,
    general: deGeneral,
    home: deHome,
    languageName: 'Deutsch',
    selectLanguage: 'Sprache auswählen',
  },
  en: {
    $vuetify: en,
    general: enGeneral,
    home: enHome,
    notfound: enNotFound,
    unexpected: enUnexpectedError,
    teamManagement: enTeamManagement,
    workspaceManagement: enWorkspaceManagement,
    memberManagement: enMemberManagement,
    validationError: enValidationError,
    languageName: 'English',
    selectLanguage: 'Select Language',
  },
  es: {
    $vuetify: es,
    general: esGeneral,
    home: esHome,
    languageName: 'Español',
    selectLanguage: 'Seleccionar idioma',
  },
  fr: {
    $vuetify: fr,
    general: frGeneral,
    home: frHome,
    languageName: 'Français',
    selectLanguage: 'Choisir la langue',
  },
}

export const defaultLang = 'en'

// Create Vue I18n instance
const i18n = createI18n({
  legacy: false, // Use Composition API
  locale: defaultLang,
  fallbackLocale: defaultLang,
  messages: additionalMessages,
})

export default i18n
